module.exports = __webpack_public_path__ + "static/img/fucheng.6f5b7f8c.png";